// extracted by mini-css-extract-plugin
export var closeButton = "_pr-2";
export var closeButtonIcon = "_pr-3";
export var lightboxContent = "_pr-1";
export var lightboxOverlay = "_pr-0";